<template>
    <div id="Container_SchedulerOptions">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="$t('SchedulerOptions.Title')" />
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12">
                <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                    <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
                        <div class="tab-pane fade show active" id="contentGeneral" role="tabpanel">
                            <b-row class="mt-3">
                                <b-col lg="12" md="12" sm="12">
                                    <fieldset class="customWells">
                                        <legend>
                                            {{$t('SchedulerOptions.TabGeneral.DoubleBooking.Label')}}
                                        </legend>
                                        <MdRadioGroup
                                            v-model="editableItem.doubleBookingByRoom"
                                            v-bind:Options="doubleBookingOptions"
                                            v-bind:Name="'radio-doubleBookingOptions'"
                                            v-bind:Stacked="false"
                                        />
                                    </fieldset>
                                </b-col>
                            </b-row>

                            <b-row class="mt-3">
                                <b-col lg="12" md="12" sm="12">
                                    <fieldset class="customWells">
                                        <legend>
                                            {{$t('SchedulerOptions.TabGeneral.ReceiptType.Label')}}
                                        </legend>
                                        <MdRadioGroup
                                            v-model="editableItem.receiptType"
                                            v-bind:Options="receiptTypeOptions"
                                            v-bind:Name="'radio-receiptTypeOptions'"
                                            v-bind:Stacked="false"
                                        />
                                    </fieldset>
                                </b-col>
                            </b-row>
                            <MdTitle
                                v-bind:Text="$t('Shared.General')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleSearch'"
                            />
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="
                                            this.$t('SchedulerOptions.TabGeneral.GeneralChkBoxes.ShowReceiptOptions')
                                        "
                                        v-bind:Name="'checkbox-ShowReceiptOptions'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showReceiptOptions"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="
                                            this.$t('SchedulerOptions.TabGeneral.GeneralChkBoxes.RequestPatientSignature')
                                        "
                                        v-bind:Name="'checkbox-RequestPatientSignature'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestPatientSignature"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="
                                            this.$t('SchedulerOptions.TabGeneral.GeneralChkBoxes.ShowAllEmployeesGroupAppt')
                                        "
                                        v-bind:Name="'checkbox-ShowAllEmployeesGroupAppt'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showAllEmployeesGroupAppt"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="
                                            this.$t('SchedulerOptions.TabGeneral.GeneralChkBoxes.HideBookedWarning')
                                        "
                                        v-bind:Name="'checkbox-HideBookedWarning'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.hideBookedWarning"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="
                                            this.$t('SchedulerOptions.TabGeneral.GeneralChkBoxes.HideCancelledApt')
                                        "
                                        v-bind:Name="'checkbox-HideCancelledApt'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.hideCancelledApt"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="
                                            this.$t('SchedulerOptions.TabGeneral.GeneralChkBoxes.EnforceLocation')
                                        "
                                        v-bind:Name="'checkbox-EnforceLocation'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.enforceLocation"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="
                                            this.$t('SchedulerOptions.TabGeneral.GeneralChkBoxes.WarnUnregisteredPatient')
                                        "
                                        v-bind:Name="'checkbox-WarnUnregisteredPatient'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.warnUnregisteredPatient"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="
                                            this.$t('SchedulerOptions.TabGeneral.GeneralChkBoxes.NotShowPatientAlerts')
                                        "
                                        v-bind:Name="'checkbox-NotShowPatientAlerts'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.notShowPatientAlerts"
                                    />
                                </b-col>
                            </b-row>
                        </div>

                        <div class="tab-pane fade" id="contentCalendarOptions" role="tabpanel">
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <b-row>
                                        <b-col cols="12">
                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabCalendarOptions.BlockingTimeColor')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleBlockingColor'"
                                            />
                                        </b-col>
                                        <b-col cols="12" class="mt-3 pl-3">
                                            <MdColor 
                                                v-bind:Title="$t('SchedulerOptions.TabCalendarOptions.Background')" 
                                                v-model="editableItem.blockTimeBackground"
                                            />
                                        </b-col>
                                    </b-row>
                                </b-col>

                                <b-col md="4" lg="4" sm="12">
                                    <b-row>
                                        <b-col cols="12">
                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabCalendarOptions.CalendarDefaultTimeFrame')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleCalendarDefaultTimeFrame'"
                                            />
                                        </b-col>
                                        <b-col cols="12">
                                            <MdSelect
                                                :key="editableItem.calenDefTimeFrame"
                                                v-bind:Label="$t('SchedulerOptions.TabCalendarOptions.Minutes')"
                                                v-bind:Options="minutesOptions"
                                                v-bind:FieldDescription="'description'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:Model="calenDefTimeFrameModel"
                                                v-bind:Multiple="false"
                                                v-bind:UseParamsAux="true"
                                                v-bind:AuxParam="{ dbField: 'calenDefTimeFrame', uiModel: calenDefTimeFrameModel }"
                                                :Input="handleComboChange"
                                            />
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="5" lg="5" sm="12">
                                    <b-row>
                                        <b-col cols="12">
                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabCalendarOptions.CalendarWorkingHours')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleCalendarWorkingHours'"
                                            />
                                        </b-col>
                                        <b-col cols="12">
                                            <b-row>
                                                <b-col md="12" lg="12" sm="12">
                                                        <MdEdit
                                                            v-bind:Id="'time-CalendarOptions-DayBegins'"
                                                            v-bind:Name="'timeDayBegins'"
                                                            v-bind:Label="$t('SchedulerOptions.TabCalendarOptions.DayBegins')"
                                                            v-bind:TypeProp="'time'"
                                                            v-model="editableItem.dayBegins"
                                                            v-bind:isReadOnly="false"
                                                        />
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col md="12" lg="12" sm="12">
                                                        <MdEdit
                                                            v-bind:Id="'time-CalendarOptions-DayEnds'"
                                                            v-bind:Name="'timeDayEnds'"
                                                            v-bind:Label="$t('SchedulerOptions.TabCalendarOptions.DayEnds')"
                                                            v-bind:TypeProp="'time'"
                                                            v-model="editableItem.dayEnds"
                                                            v-bind:isReadOnly="false"
                                                        />
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>

                            <MdTitle
                                v-bind:Text="$t('SchedulerOptions.TabCalendarOptions.SchedulerDb')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleSchedulerDb'"
                            />
                            <div class="mt-3 pl-3">
                                <b-row class="align-items-baseline no-gutters">
                                    <b-col md="3" lg="3" sm="12">
                                        <label class="textlabel m-0 pt-1 mr-3" style="white-space: nowrap; font-family: inherit;">
                                            {{ $t('SchedulerOptions.TabCalendarOptions.DefaultDateRangeIs') }}
                                        </label>
                                    </b-col>
                                    <b-col md="9" lg="9" sm="12" class="d-flex align-items-baseline justify-content-start">
                                        <div class="ml-2 mr-3" style="width: 100px; min-width: 100px;">
                                            <MdEdit
                                                v-bind:Id="'num-CalendarOptions-DaysFromCurrent'"
                                                v-bind:Name="'numDaysFromCurrent'"
                                                v-bind:Label="''"
                                                v-bind:Placeholder="'0'"
                                                v-bind:TypeProp="'number'"
                                                v-bind:Min="'0'"
                                                v-bind:Max="'1000'"
                                                v-model.number="editableItem.daysFromCurrent"
                                                v-bind:isReadOnly="false"
                                            />
                                        </div>
                                        <span class="textlabel-suffix font-weight-bold" style="white-space: nowrap; font-family: inherit; font-size: 14px;">
                                            {{ $t('SchedulerOptions.TabCalendarOptions.DaysFromCurrentDate') }}
                                        </span>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="contentAppointmentOptions" role="tabpanel">
                            <MdTitle
                                v-bind:Text="$t('SchedulerOptions.TabAppointmentOptions.AppointmentNotesTemplate')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleAppointmentNotesTemplate'"
                            />
                            <b-row>
                                <b-col md="6" lg="6" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('SchedulerOptions.TabAppointmentOptions.DoNotDefaultNote')"
                                        v-bind:Name="'checkbox-AppointmentOptions-DoNotDefault'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="'Y'"
                                        v-bind:UncheckedValue="'N'"
                                        v-model="editableItem.doNotDefaultNote"
                                    />
                                </b-col>
                                <b-col md="6" lg="6" sm="12">
                                    <MdEdit
                                        v-bind:Id="'txt-AppointmentOptions-DatasetName-viewNameTemplate'"
                                        v-bind:Name="'txtDatasetNameviewNameTemplate'"
                                        v-bind:Label="$t('SchedulerOptions.TabAppointmentOptions.DatasetName')"
                                        v-bind:Placeholder="''"
                                        v-model="editableItem.viewNameTemplate"
                                        v-bind:isReadOnly="false"
                                    />
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col md="12" lg="12" sm="12">
                                    <MdMemo
                                        v-bind:Name="'memoAppointmentNote'"
                                        v-bind:Label="$t('SchedulerOptions.TabAppointmentOptions.Note')"
                                        v-bind:VisibleLabel="true"
                                        v-bind:Rows="'4'"
                                        v-bind:MaxRows="'8'"
                                        v-bind:value="editableItem.contentTemplate"
                                        v-on:input="editableItem.contentTemplate = $event"
                                        v-bind:isReadOnly="false"
                                    />
                                </b-col>
                            </b-row>
                            <MdTitle
                                v-bind:Text="$t('SchedulerOptions.TabAppointmentOptions.UseDatasetToLoadApptTypes')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleUseDatasetToLoadApptTypes'"
                            />
                            <b-row>
                                <b-col md="12" lg="12" sm="12">
                                    <MdEdit
                                        v-bind:Id="'txt-AppointmentOptions-DatasetName-useDatasetToLoadApptTypes'"
                                        v-bind:Name="'txtDatasetNameuseDatasetToLoadApptTypes'"
                                        v-bind:Label="$t('SchedulerOptions.TabAppointmentOptions.DatasetName')"
                                        v-bind:Placeholder="''"
                                        v-model="editableItem.useDatasetToLoadApptTypes"
                                        v-bind:isReadOnly="false"
                                    />
                                </b-col>
                            </b-row>
                            <MdTitle
                                v-bind:Text="$t('SchedulerOptions.TabAppointmentOptions.ShowCustomReminder')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleShowCustomReminder'"
                            />
                            <b-row>
                                <b-col md="12" lg="12" sm="12">
                                    <MdMemo
                                        v-bind:Name="'memoAppointmentcustomReminder'"
                                        v-bind:Label="$t('SchedulerOptions.TabAppointmentOptions.Note')"
                                        v-bind:VisibleLabel="true"
                                        v-bind:Rows="'4'"
                                        v-bind:MaxRows="'8'"
                                        v-bind:value="editableItem.customReminder"
                                        v-on:input="editableItem.customReminder = $event"
                                        v-bind:isReadOnly="false"
                                    />
                                </b-col>
                            </b-row>
                            <MdTitle
                                v-bind:Text="$t('SchedulerOptions.TabAppointmentOptions.AllowPatientShowedUp')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleAllowPatientShowedUp'"
                            />
                            <b-row>
                                <b-col md="6" lg="6" sm="12">
									<MdEdit
										v-bind:Id="'num-AppointmentOptions-MinBefore'"
										v-bind:Name="'numMinBefore'"
										v-bind:Label="$t('SchedulerOptions.TabAppointmentOptions.MinBeforeAppointment')"
										v-bind:Placeholder="'0'"
										v-bind:TypeProp="'number'"
										v-bind:Min="'0'"
										v-bind:Max="'1000'"
										v-model.number="editableItem.allowShowUpMinBefore"
										v-bind:isReadOnly="false"
									/>
                                </b-col>

                                <b-col md="6" lg="6" sm="12">
									<MdEdit
										v-bind:Id="'num-AppointmentOptions-MinAfter'"
										v-bind:Name="'numMinAfter'"
										v-bind:Label="$t('SchedulerOptions.TabAppointmentOptions.MinAfterAppointment')"
										v-bind:Placeholder="'0'"
										v-bind:TypeProp="'number'"
										v-bind:Min="'0'"
										v-bind:Max="'1000'"
										v-model.number="editableItem.allowShowUpMinAfter"
										v-bind:isReadOnly="false"
									/>
                                </b-col>
                            </b-row>
                        </div>

                        <div class="tab-pane fade" id="contentNotifications" role="tabpanel">

                            <div class="accordion" role="tablist">
                                
                                <b-card no-body class="mb-1">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-patient class="collapseBTN text-left">
                                            <b-icon icon="person-fill" class="mr-2" aria-hidden="true"></b-icon>
                                            {{ $t('SchedulerOptions.TabNotifications.AccPatient') }}
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-patient" v-model="accordionStates.patient" accordion="notifications-accordion" role="tabpanel">
                                        <b-card-body>
                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabNotifications.EmailToPatientAfter')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleEmailToPatient'"
                                            />

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.CreatingAppointment')"
                                                        v-bind:Name="'checkbox-EmailToPatient-CreatingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.emailPatientCreate"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.emailPatientCreateMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="emailMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="emailPatientCreateMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.emailPatientCreate"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'emailPatientCreateMsgtype', uiModel: emailPatientCreateMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.ReschedulingAppointment')"
                                                        v-bind:Name="'checkbox-EmailToPatient-ReschedulingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.emailPatientReScheduled"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.emailPatientReScheduledMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="emailMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="emailPatientReScheduledMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.emailPatientReScheduled"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'emailPatientReScheduledMsgtype', uiModel: emailPatientReScheduledMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.DeletingAppointment')"
                                                        v-bind:Name="'checkbox-EmailToPatient-DeletingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.emailPatientDelete"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.emailPatientDeleteMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="emailMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="emailPatientDeleteMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.emailPatientDelete"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'emailPatientDeleteMsgtype', uiModel: emailPatientDeleteMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabNotifications.TextToPatientAfter')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleTextToPatient'"
                                            />

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.CreatingAppointment')"
                                                        v-bind:Name="'checkbox-TextToPatient-CreatingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.smspatientCreate"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.smspatientCreateMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="smsMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="smsPatientCreateMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.smspatientCreate"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'smspatientCreateMsgtype', uiModel: smsPatientCreateMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.ReschedulingAppointment')"
                                                        v-bind:Name="'checkbox-TextToPatient-ReschedulingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.smspatientReScheduled"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.smspatientReScheduledMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="smsMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="smsPatientReScheduledMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.smspatientReScheduled"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'smspatientReScheduledMsgtype', uiModel: smsPatientReScheduledMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.DeletingAppointment')"
                                                        v-bind:Name="'checkbox-TextToPatient-DeletingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.smspatientDelete"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.smspatientDeleteMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="smsMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="smsPatientDeleteMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.smspatientDelete"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'smspatientDeleteMsgtype', uiModel: smsPatientDeleteMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabNotifications.WhatsAppToPatientAfter')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleWhatsAppToPatient'"
                                            />

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.CreatingAppointment')"
                                                        v-bind:Name="'checkbox-WhatsAppToPatient-CreatingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.waPatientCreate"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.waPatientCreateMSGType"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="whatsappMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="waPatientCreateMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.waPatientCreate"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'waPatientCreateMSGType', uiModel: waPatientCreateMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.ReschedulingAppointment')"
                                                        v-bind:Name="'checkbox-WhatsAppToPatient-ReschedulingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.waPatientReScheduled"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.waPatientReScheduledMSGType"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="whatsappMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="waPatientReScheduledMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.waPatientReScheduled"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'waPatientReScheduledMSGType', uiModel: waPatientReScheduledMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.DeletingAppointment')"
                                                        v-bind:Name="'checkbox-WhatsAppToPatient-DeletingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.waPatientDelete"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.waPatientDeleteMSGType"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="whatsappMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="waPatientDeleteMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.waPatientDelete"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'waPatientDeleteMSGType', uiModel: waPatientDeleteMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-contact class="collapseBTN text-left">
                                            <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                                            {{ $t('SchedulerOptions.TabNotifications.AccContact')}}
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-contact" v-model="accordionStates.contact" accordion="notifications-accordion" role="tabpanel">
                                        <b-card-body>

                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabNotifications.EmailToContactAfter')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleEmailToContact'"
                                            />

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.CreatingAppointment')"
                                                        v-bind:Name="'checkbox-EmailToContact-CreatingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.emailContactCreate"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.emailContactCreateMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="emailMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="emailContactCreateMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.emailContactCreate"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'emailContactCreateMsgtype', uiModel: emailContactCreateMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.ReschedulingAppointment')"
                                                        v-bind:Name="'checkbox-EmailToContact-ReschedulingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.emailContactReScheduled"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.emailContactReScheduledMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="emailMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="emailContactReScheduledMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.emailContactReScheduled"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'emailContactReScheduledMsgtype', uiModel: emailContactReScheduledMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.DeletingAppointment')"
                                                        v-bind:Name="'checkbox-EmailToContact-DeletingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.emailContactDelete"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.emailContactDeleteMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="emailMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="emailContactDeleteMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.emailContactDelete"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'emailContactDeleteMsgtype', uiModel: emailContactDeleteMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabNotifications.TextToContactAfter')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleTextToContact'"
                                            />

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.CreatingAppointment')"
                                                        v-bind:Name="'checkbox-TextToContact-CreatingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.textContactCreate"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.textContactCreateMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="smsMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="smsContactCreateMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.textContactCreate"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'textContactCreateMsgtype', uiModel: smsContactCreateMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.ReschedulingAppointment')"
                                                        v-bind:Name="'checkbox-TextToContact-ReschedulingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.textContactReScheduled"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.textContactReScheduledMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="smsMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="smsContactReScheduledMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.textContactReScheduled"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'textContactReScheduledMsgtype', uiModel: smsContactReScheduledMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.DeletingAppointment')"
                                                        v-bind:Name="'checkbox-TextToContact-DeletingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.textContactDelete"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.textContactDeleteMsgtype"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="smsMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="smsContactDeleteMsgtypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.textContactDelete"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'textContactDeleteMsgtype', uiModel: smsContactDeleteMsgtypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabNotifications.WhatsAppToContactAfter')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleWhatsAppToContact'"
                                            />

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.CreatingAppointment')"
                                                        v-bind:Name="'checkbox-WhatsAppToContact-CreatingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.waContactCreate"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.waContactCreateMSGType"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="whatsappMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="waContactCreateMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.waContactCreate"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'waContactCreateMSGType', uiModel: waContactCreateMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.ReschedulingAppointment')"
                                                        v-bind:Name="'checkbox-WhatsAppToContact-ReschedulingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.waContactReScheduled"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.waContactReScheduledMSGType"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="whatsappMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="waContactReScheduledMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.waContactReScheduled"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'waContactReScheduledMSGType', uiModel: waContactReScheduledMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <MdCheckBox
                                                        v-bind:Label="$t('SchedulerOptions.TabNotifications.DeletingAppointment')"
                                                        v-bind:Name="'checkbox-WhatsAppToContact-DeletingAppointment'"
                                                        v-bind:ClassProp="'AlignCheck'"
                                                        v-bind:CheckedValue="true"
                                                        v-bind:UncheckedValue="false"
                                                        v-model="editableItem.waContactDelete"
                                                    />
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.waContactDeleteMSGType"
                                                        v-bind:Label="$t('scheduleNotify.mType')"
                                                        v-bind:Options="whatsappMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="waContactDeleteMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:IsDisabled="!editableItem.waContactDelete"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'waContactDeleteMSGType', uiModel: waContactDeleteMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-telehealth class="collapseBTN text-left">
                                            <b-icon icon="chat-square-text-fill" class="mr-2" aria-hidden="true"></b-icon>
                                            {{ $t('SchedulerOptions.TabNotifications.AccTelehealt')}}
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-telehealth" v-model="accordionStates.telehealth" accordion="notifications-accordion" role="tabpanel">
                                        <b-card-body>

                                            <MdTitle
                                                v-bind:Text="$t('SchedulerOptions.TabNotifications.TelehealthReminder')"
                                                v-bind:isSubtitle="true"
                                                v-bind:Name="'T_TitleTelehealthReminder'"
                                            />
                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <label class="textlabel pt-2">{{ $t('SchedulerOptions.TabNotifications.PatientEmailMsgType') }}</label>
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.emailPatientTelehealthMSGType"
                                                        v-bind:Label="''"
                                                        v-bind:Options="emailMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="emailPatientTelehealthMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'emailPatientTelehealthMSGType', uiModel: emailPatientTelehealthMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <label class="textlabel pt-2">{{ $t('SchedulerOptions.TabNotifications.PatientTextMsgType') }}</label>
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.textPatientTelehealthMSGType"
                                                        v-bind:Label="''"
                                                        v-bind:Options="smsMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="textPatientTelehealthMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'textPatientTelehealthMSGType', uiModel: textPatientTelehealthMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <label class="textlabel pt-2">{{ $t('SchedulerOptions.TabNotifications.PatientWhatsAppMsgType') }}</label>
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.waPatientTelehealthMSGType"
                                                        v-bind:Label="''"
                                                        v-bind:Options="whatsappMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="waPatientTelehealthMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'waPatientTelehealthMSGType', uiModel: waPatientTelehealthMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <label class="textlabel pt-2">{{ $t('SchedulerOptions.TabNotifications.ContactEmailMsgType') }}</label>
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.emailContactTelehealthMSGType"
                                                        v-bind:Label="''"
                                                        v-bind:Options="emailMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="emailContactTelehealthMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'emailContactTelehealthMSGType', uiModel: emailContactTelehealthMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <label class="textlabel pt-2">{{ $t('SchedulerOptions.TabNotifications.ContactTextMsgType') }}</label>
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.textContactTelehealthMSGType"
                                                        v-bind:Label="''"
                                                        v-bind:Options="smsMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="textContactTelehealthMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'textContactTelehealthMSGType', uiModel: textContactTelehealthMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="4" lg="4" sm="12">
                                                    <label class="textlabel pt-2">{{ $t('SchedulerOptions.TabNotifications.ContactWhatsAppMsgType') }}</label>
                                                </b-col>
                                                <b-col md="8" lg="8" sm="12">
                                                    <MdSelect
                                                        :key="editableItem.waContactTelehealthMSGType"
                                                        v-bind:Label="''"
                                                        v-bind:Options="whatsappMsgTypeList"
                                                        v-bind:FieldDescription="'description'"
                                                        v-bind:FieldCode="'code'"
                                                        v-bind:Model="waContactTelehealthMSGTypeModel"
                                                        v-bind:Multiple="false"
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:AuxParam="{ dbField: 'waContactTelehealthMSGType', uiModel: waContactTelehealthMSGTypeModel }"
                                                        :Input="handleComboChange"
                                                    />
                                                </b-col>
                                            </b-row>

                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                            </div>


                        </div>
                    </div>
                </MdTabList>
            </b-col>
        </b-row>
        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.BtnSave')"
                v-bind:Name="'btnSaveRole'"
                v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                v-on:click="save"
            />
        </div>
    </div>
</template>

<script>
import MessageTemplateSetupsService from '@/services/messagetemplatesetups.service';
import SchedulerOptionsService from '@/services/schedulersoptions.service';
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import { EventBus } from '@/event-bus.js';

export default {
    name: 'schedulerOptions',
    mixins: [DBFunctions, ShowMessage],

    data() {
        return {
            accordionStates: {
                patient: true,
                contact: false,
                telehealth: false
            },
            emailMsgTypeList: [],
            smsMsgTypeList: [],
            whatsappMsgTypeList: [],
            emailPatientCreateMsgtypeModel: { code: null, description: null },
            emailPatientReScheduledMsgtypeModel: { code: null, description: null },
            emailPatientDeleteMsgtypeModel: { code: null, description: null },

            smsPatientCreateMsgtypeModel: { code: null, description: null },
            smsPatientReScheduledMsgtypeModel: { code: null, description: null },
            smsPatientDeleteMsgtypeModel: { code: null, description: null },

            waPatientCreateMSGTypeModel: { code: null, description: null },
            waPatientReScheduledMSGTypeModel: { code: null, description: null },
            waPatientDeleteMSGTypeModel: { code: null, description: null },

            emailContactCreateMsgtypeModel: { code: null, description: null },
            emailContactReScheduledMsgtypeModel: { code: null, description: null },
            emailContactDeleteMsgtypeModel: { code: null, description: null },

            smsContactCreateMsgtypeModel: { code: null, description: null },
            smsContactReScheduledMsgtypeModel: { code: null, description: null },
            smsContactDeleteMsgtypeModel: { code: null, description: null },

            waContactCreateMSGTypeModel: { code: null, description: null },
            waContactReScheduledMSGTypeModel: { code: null, description: null },
            waContactDeleteMSGTypeModel: { code: null, description: null },

            emailPatientTelehealthMSGTypeModel: { code: null, description: null },
            textPatientTelehealthMSGTypeModel: { code: null, description: null },
            waPatientTelehealthMSGTypeModel: { code: null, description: null },
            
            emailContactTelehealthMSGTypeModel: { code: null, description: null },
            textContactTelehealthMSGTypeModel: { code: null, description: null },
            waContactTelehealthMSGTypeModel: { code: null, description: null },


            editableItem: {
                //General
                doubleBookingByRoom: '',
                receiptType: '',
                showReceiptOptions: false,
                requestPatientSignature: false,
                showAllEmployeesGroupAppt: false,
                hideBookedWarning: false,
                hideCancelledApt: false,
                enforceLocation: false,
                warnUnregisteredPatient: false,
                notShowPatientAlerts: false,
                //Calendar Options
                blockTimeBackground: null,
                calenDefTimeFrame: null,
                dayBegins:null,
                dayEnds:null,
                daysFromCurrent: null,
                //Appointment Options
                doNotDefaultNote: false,
                viewNameTemplate: '',
                contentTemplate: '',
                useDatasetToLoadApptTypes: '',
                customReminder: '',
                allowShowUpMinBefore: null,
                allowShowUpMinAfter: null,


                // ---- Patient: Email ----
                emailPatientCreate: false,
                emailPatientCreateMsgtype: '',
                emailPatientReScheduled: false,
                emailPatientReScheduledMsgtype: '',
                emailPatientDelete: false,
                emailPatientDeleteMsgtype: '',
                // ---- Patient: TEXT / SMS ----
                smspatientCreate: false,
                smspatientCreateMsgtype: '',
                smspatientReScheduled: false,
                smspatientReScheduledMsgtype: '',
                smspatientDelete: false,
                smspatientDeleteMsgtype: '',
                // ---- Patient: WHATSAPP ----
                waPatientCreate: false,
                waPatientCreateMSGType: '',
                waPatientReScheduled: false,
                waPatientReScheduledMSGType: '',
                waPatientDelete: false,
                waPatientDeleteMSGType: '',
                // ---- Contact: Email ----
                emailContactCreate: false,
                emailContactCreateMsgtype: '',
                emailContactReScheduled: false,
                emailContactReScheduledMsgtype: '',
                emailContactDelete: false,
                emailContactDeleteMsgtype: '',
                // ---- Contact: TEXT / SMS ----
                textContactCreate: false,
                textContactCreateMsgtype: '',
                textContactReScheduled: false,
                textContactReScheduledMsgtype: '',
                textContactDelete: false,
                textContactDeleteMsgtype: '',
                // ---- Contact: WHATSAPP ----
                waContactCreate: false,
                waContactCreateMSGType: '',
                waContactReScheduled: false,
                waContactReScheduledMSGType: '',
                waContactDelete: false,
                waContactDeleteMSGType: '',
                // ---- Telehealth: Patient ----
                emailPatientTelehealthMSGType: '',
                textPatientTelehealthMSGType: '',
                waPatientTelehealthMSGType: '',
                // ---- Telehealth: Contact ----
                emailContactTelehealthMSGType: '',
                textContactTelehealthMSGType: '',
                waContactTelehealthMSGType: '',
            },
            minutesOptions: [
                { code: 5, description: '5' },
                { code: 10, description: '10' },
                { code: 15, description: '15' },
                { code: 30, description: '30' },
                { code: 60, description: '60' }
            ],
            calenDefTimeFrameModel: { code: null, description: null },
            doubleBookingOptions: [
                { text: this.$t('SchedulerOptions.TabGeneral.DoubleBooking.Allow'), value: 'A' },
                { text: this.$t('SchedulerOptions.TabGeneral.DoubleBooking.Warn'), value: 'W' },
                { text: this.$t('SchedulerOptions.TabGeneral.DoubleBooking.Deny'), value: 'P' }
            ],
            receiptTypeOptions: [
                { text: this.$t('SchedulerOptions.TabGeneral.ReceiptType.PatientInvoice'), value: 'I' },
                { text: this.$t('SchedulerOptions.TabGeneral.ReceiptType.PatientStatementSummary'), value: 'S' },
                { text: this.$t('SchedulerOptions.TabGeneral.ReceiptType.PatientTransactionSummary'), value: 'T' },
                { text: this.$t('SchedulerOptions.TabGeneral.ReceiptType.PatientTransactionSummaryNotAgingInfo'), value: 'A' }
            ],
            tablist: [
                { title: this.$t('Shared.General'), link: '#contentGeneral', active: true },
                { title: this.$t('SchedulerOptions.TabCalendarOptions.Title'), link: '#contentCalendarOptions' },
                { title: this.$t('SchedulerOptions.TabAppointmentOptions.Title'), link: '#contentAppointmentOptions' },
                { title: this.$t('SchedulerOptions.TabNotifications.Title'), link: '#contentNotifications' }
            ],
            pendingChanges: false
        };
    },

    methods: {
        save() {
            if (!this.validate()) return;

            const updatePayload = JSON.parse(JSON.stringify(this.editableItem));
            //Change color #RRGGBB to int
            if (updatePayload.blockTimeBackground && String(updatePayload.blockTimeBackground).startsWith('#')) {
                updatePayload.blockTimeBackground = this.hexToDelphiColor(updatePayload.blockTimeBackground);
            }

            const currentId = this.editableItem.recId;


            const serviceAction = !currentId
                ? SchedulerOptionsService.add(updatePayload)
                : SchedulerOptionsService.update(currentId, updatePayload);

            serviceAction
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        });
                        
                        this.getSchedulerOptions();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        executeModelCleanup(rules) {
            if (!rules || !Array.isArray(rules)) return;

            rules.forEach(rule => {
                if (!this.editableItem[rule.checkbox]) {
                    this.editableItem[rule.dbField] = null;
                    
                    this.$set(rule.model, 'code', null);
                    this.$set(rule.model, 'description', null);
                }
            });
        },


        validate() {
            let isFormValid = true;

            const validationRules = [
                // ---- PATIENT ----
                { checkbox: 'emailPatientCreate', dbField: 'emailPatientCreateMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.EmailToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.CreatingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },
                { checkbox: 'emailPatientReScheduled', dbField: 'emailPatientReScheduledMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.EmailToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.ReschedulingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },
                { checkbox: 'emailPatientDelete', dbField: 'emailPatientDeleteMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.EmailToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.DeletingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },
                { checkbox: 'smspatientCreate', dbField: 'smspatientCreateMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.TextToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.CreatingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },
                { checkbox: 'smspatientReScheduled', dbField: 'smspatientReScheduledMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.TextToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.ReschedulingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },
                { checkbox: 'smspatientDelete', dbField: 'smspatientDeleteMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.TextToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.DeletingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },
                { checkbox: 'waPatientCreate', dbField: 'waPatientCreateMSGType', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.WhatsAppToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.CreatingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },
                { checkbox: 'waPatientReScheduled', dbField: 'waPatientReScheduledMSGType', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.WhatsAppToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.ReschedulingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },
                { checkbox: 'waPatientDelete', dbField: 'waPatientDeleteMSGType', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.WhatsAppToPatientAfter', actionKey: 'SchedulerOptions.TabNotifications.DeletingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'patient'
                },

                // ---- CONTACT ----
                { checkbox: 'emailContactCreate', dbField: 'emailContactCreateMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.EmailToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.CreatingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                },
                { checkbox: 'emailContactReScheduled', dbField: 'emailContactReScheduledMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.EmailToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.ReschedulingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                },
                { checkbox: 'emailContactDelete', dbField: 'emailContactDeleteMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.EmailToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.DeletingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                },
                { checkbox: 'textContactCreate', dbField: 'textContactCreateMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.TextToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.CreatingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                },
                { checkbox: 'textContactReScheduled', dbField: 'textContactReScheduledMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.TextToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.ReschedulingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                },
                { checkbox: 'textContactDelete', dbField: 'textContactDeleteMsgtype', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.TextToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.DeletingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                },
                { checkbox: 'waContactCreate', dbField: 'waContactCreateMSGType', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.WhatsAppToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.CreatingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                },
                { checkbox: 'waContactReScheduled', dbField: 'waContactReScheduledMSGType', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.WhatsAppToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.ReschedulingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                },
                { checkbox: 'waContactDelete', dbField: 'waContactDeleteMSGType', 
                  msgTypeKey: 'SchedulerOptions.TabNotifications.WhatsAppToContactAfter', actionKey: 'SchedulerOptions.TabNotifications.DeletingAppointment',
                  tabLink: '#contentNotifications', accordionProp: 'contact'
                }
            ];

            for (let i = 0; i < validationRules.length; i++) {
                const rule = validationRules[i];
                
                if (this.editableItem[rule.checkbox] === true) {
                    const value = this.editableItem[rule.dbField];
                    
                    if (!value || String(value).trim().length === 0) {
                        isFormValid = false;
                        const msgTypeDescription = this.$t(rule.msgTypeKey);
                        const actionText = this.$t(rule.actionKey);

                        const tabButton = document.querySelector(`a[href="${rule.tabLink}"]`);
                        if (tabButton) {
                            tabButton.click(); 
                        }

                        if (rule.tabLink === '#contentNotifications' && rule.accordionProp) {
                            setTimeout(() => {
                                this.accordionStates.patient = false;
                                this.accordionStates.contact = false;
                                this.accordionStates.telehealth = false;
                                
                                this.accordionStates[rule.accordionProp] = true;
                            }, 250);
                        }
                        
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            `${this.$t('scheduleNotify.mType')} ${this.$t('SchedulerOptions.IsRequired')} (${msgTypeDescription} / ${actionText})`,
                            'errorAutoHide'
                        );
                        
                        break;
                    }
                }
            }

            if (isFormValid) {
                //PATIENT
                //EMAIL
                this.executeModelCleanup([
                    { checkbox: 'emailPatientCreate', dbField: 'emailPatientCreateMsgtype', model: this.emailPatientCreateMsgtypeModel },
                    { checkbox: 'emailPatientReScheduled', dbField: 'emailPatientReScheduledMsgtype', model: this.emailPatientReScheduledMsgtypeModel },
                    { checkbox: 'emailPatientDelete', dbField: 'emailPatientDeleteMsgtype', model: this.emailPatientDeleteMsgtypeModel }
                ]);
                //TEXT/SMS
                this.executeModelCleanup([
                    { checkbox: 'smspatientCreate', dbField: 'smspatientCreateMsgtype', model: this.smsPatientCreateMsgtypeModel },
                    { checkbox: 'smspatientReScheduled', dbField: 'smspatientReScheduledMsgtype', model: this.smsPatientReScheduledMsgtypeModel },
                    { checkbox: 'smspatientDelete', dbField: 'smspatientDeleteMsgtype', model: this.smsPatientDeleteMsgtypeModel }
                ]);
                //WHATSAPP
                this.executeModelCleanup([
                    { checkbox: 'waPatientCreate', dbField: 'waPatientCreateMSGType', model: this.waPatientCreateMSGTypeModel },
                    { checkbox: 'waPatientReScheduled', dbField: 'waPatientReScheduledMSGType', model: this.waPatientReScheduledMSGTypeModel },
                    { checkbox: 'waPatientDelete', dbField: 'waPatientDeleteMSGType', model: this.waPatientDeleteMSGTypeModel }
                ]);

                //CONTACT
                //EMAIL
                this.executeModelCleanup([
                    { checkbox: 'emailContactCreate', dbField: 'emailContactCreateMsgtype', model: this.emailContactCreateMsgtypeModel },
                    { checkbox: 'emailContactReScheduled', dbField: 'emailContactReScheduledMsgtype', model: this.emailContactReScheduledMsgtypeModel },
                    { checkbox: 'emailContactDelete', dbField: 'emailContactDeleteMsgtype', model: this.emailContactDeleteMsgtypeModel }
                ]);
                //TEXT/SMS
                this.executeModelCleanup([
                    { checkbox: 'textContactCreate', dbField: 'textContactCreateMsgtype', model: this.smsContactCreateMsgtypeModel },
                    { checkbox: 'textContactReScheduled', dbField: 'textContactReScheduledMsgtype', model: this.smsContactReScheduledMsgtypeModel },
                    { checkbox: 'textContactDelete', dbField: 'textContactDeleteMsgtype', model: this.smsContactDeleteMsgtypeModel }
                ]);
                //WHATSAPP
                this.executeModelCleanup([
                    { checkbox: 'waContactCreate', dbField: 'waContactCreateMSGType', model: this.waContactCreateMSGTypeModel },
                    { checkbox: 'waContactReScheduled', dbField: 'waContactReScheduledMSGType', model: this.waContactReScheduledMSGTypeModel },
                    { checkbox: 'waContactDelete', dbField: 'waContactDeleteMSGType', model: this.waContactDeleteMSGTypeModel }
                ]);
            }

            return isFormValid;
        },

        async getLookupMsgTypes() {
            let lookupParams = {
                SearchCriteria: null,
                OrderBy: 'MessageType',
                ShowIn: 'SCHEDULER'   // Only on Scheduler
            };
            this.emailMsgTypeList = [];
            this.smsMsgTypeList = [];
            this.whatsappMsgTypeList = [];

            const TYPES = {
                EMAIL: 'EMAIL',
                TEXT: 'TEXT',
                WHATSAPP: 'WHATSAPP'
            };

            return MessageTemplateSetupsService.getAll(lookupParams)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        response.data.forEach(element => {
                            const currentType = element.notificationType ? element.notificationType.trim().toUpperCase() : '';
                            const templateObject = {
                                code: element.messageType ? element.messageType.trim() : '',
                                description: element.description || element.messageType
                            };

                            switch (currentType) {
                                case TYPES.EMAIL:
                                    this.emailMsgTypeList.push(templateObject);
                                    //For messaging purposes only, let's treat WhatsApp-style messages as if they were emails (since WhatsApp isn't implemented yet).
                                    this.whatsappMsgTypeList.push(templateObject);
                                    break;
                                    
                                case TYPES.TEXT:
                                    this.smsMsgTypeList.push(templateObject);
                                    break;
                                    
                                case TYPES.WHATSAPP:
                                    this.whatsappMsgTypeList.push(templateObject);
                                    break;
                                    
                                default:
                                    console.trace('Unknown Current Message TYPE on Scheduler Options.');
                                    break;
                            }
                        });
                    }
                });
        },

        syncComboModel(comboModel, dataNode) {
            if (dataNode) {
                this.$set(comboModel, 'code', dataNode.code);
                this.$set(comboModel, 'description', dataNode.description);
            } else {
                this.$set(comboModel, 'code', null);
                this.$set(comboModel, 'description', null);
            }
        },

        async getSchedulerOptions() {
            await SchedulerOptionsService.getAll()
                .then(settingsResponse => {
                    if (settingsResponse.status == '200' && settingsResponse.data) {
                        if (Array.isArray(settingsResponse.data) && settingsResponse.data.length >= 1) {
                            this.editableItem = settingsResponse.data[0];
                            //console.log(JSON.stringify(this.editableItem, null, 2));
                            if (this.editableItem.blockTimeBackground !== null && this.editableItem.blockTimeBackground !== undefined) {
                                this.editableItem.blockTimeBackground = this.delphiColorToHex(this.editableItem.blockTimeBackground);
                            }
                            if (this.editableItem.daysFromCurrent !== null && this.editableItem.daysFromCurrent !== undefined) {
                                this.editableItem.daysFromCurrent = String(this.editableItem.daysFromCurrent);
                            }
                            let dataMinutes = this.minutesOptions.find(element => element.code == this.editableItem.calenDefTimeFrame);
                            this.syncComboModel(this.calenDefTimeFrameModel, dataMinutes);

                            let dataCreate = this.emailMsgTypeList.find(
                                element => element.code == this.editableItem.emailPatientCreateMsgtype
                            );
                            let dataReScheduled = this.emailMsgTypeList.find(
                                element => element.code == this.editableItem.emailPatientReScheduledMsgtype
                            );
                            let dataDelete = this.emailMsgTypeList.find(
                                element => element.code == this.editableItem.emailPatientDeleteMsgtype
                            );
                            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                            //PATIENT: EMAIL
                            this.syncComboModel(this.emailPatientCreateMsgtypeModel, dataCreate);
                            this.syncComboModel(this.emailPatientReScheduledMsgtypeModel, dataReScheduled);
                            this.syncComboModel(this.emailPatientDeleteMsgtypeModel, dataDelete);

                            dataCreate = this.smsMsgTypeList.find(element => element.code == this.editableItem.smspatientCreateMsgtype);
                            dataReScheduled = this.smsMsgTypeList.find(element => element.code == this.editableItem.smspatientReScheduledMsgtype);
                            dataDelete = this.smsMsgTypeList.find(element => element.code == this.editableItem.smspatientDeleteMsgtype);

                            //PATIENT: TEXT/SMS
                            this.syncComboModel(this.smsPatientCreateMsgtypeModel, dataCreate);
                            this.syncComboModel(this.smsPatientReScheduledMsgtypeModel, dataReScheduled);
                            this.syncComboModel(this.smsPatientDeleteMsgtypeModel, dataDelete);

                            dataCreate = this.whatsappMsgTypeList.find(element => element.code == this.editableItem.waPatientCreateMSGType);
                            dataReScheduled = this.whatsappMsgTypeList.find(element => element.code == this.editableItem.waPatientReScheduledMSGType);
                            dataDelete = this.whatsappMsgTypeList.find(element => element.code == this.editableItem.waPatientDeleteMSGType);

                            //PATIENT: WHATSAPP
                            this.syncComboModel(this.waPatientCreateMSGTypeModel, dataCreate);
                            this.syncComboModel(this.waPatientReScheduledMSGTypeModel, dataReScheduled);
                            this.syncComboModel(this.waPatientDeleteMSGTypeModel, dataDelete);
                            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                            //CONTACT: EMAIL
                            dataCreate = this.emailMsgTypeList.find(element => element.code == this.editableItem.emailContactCreateMsgtype);
                            dataReScheduled = this.emailMsgTypeList.find(element => element.code == this.editableItem.emailContactReScheduledMsgtype);
                            dataDelete = this.emailMsgTypeList.find(element => element.code == this.editableItem.emailContactDeleteMsgtype);
                        
                            this.syncComboModel(this.emailContactCreateMsgtypeModel, dataCreate);
                            this.syncComboModel(this.emailContactReScheduledMsgtypeModel, dataReScheduled);
                            this.syncComboModel(this.emailContactDeleteMsgtypeModel, dataDelete);

                            //CONTACT: TEXT/SMS
                            dataCreate = this.smsMsgTypeList.find(element => element.code == this.editableItem.textContactCreateMsgtype);
                            dataReScheduled = this.smsMsgTypeList.find(element => element.code == this.editableItem.textContactReScheduledMsgtype);
                            dataDelete = this.smsMsgTypeList.find(element => element.code == this.editableItem.textContactDeleteMsgtype);
                        
                            this.syncComboModel(this.smsContactCreateMsgtypeModel, dataCreate);
                            this.syncComboModel(this.smsContactReScheduledMsgtypeModel, dataReScheduled);
                            this.syncComboModel(this.smsContactDeleteMsgtypeModel, dataDelete);

                            //CONTACT: WHATSAPP
                            dataCreate = this.whatsappMsgTypeList.find(element => element.code == this.editableItem.waContactCreateMSGType);
                            dataReScheduled = this.whatsappMsgTypeList.find(element => element.code == this.editableItem.waContactReScheduledMSGType);
                            dataDelete = this.whatsappMsgTypeList.find(element => element.code == this.editableItem.waContactDeleteMSGType);
                        
                            this.syncComboModel(this.waContactCreateMSGTypeModel, dataCreate);
                            this.syncComboModel(this.waContactReScheduledMSGTypeModel, dataReScheduled);
                            this.syncComboModel(this.waContactDeleteMSGTypeModel, dataDelete);

                            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                            //TELEHEALT :PATIENT
                            //EMAIL
                            dataCreate = this.emailMsgTypeList.find(element => element.code == this.editableItem.emailPatientTelehealthMSGType);
                            this.syncComboModel(this.emailPatientTelehealthMSGTypeModel, dataCreate);
                            //TEXT/SMS
                            dataCreate = this.smsMsgTypeList.find(element => element.code == this.editableItem.textPatientTelehealthMSGType);
                            this.syncComboModel(this.textPatientTelehealthMSGTypeModel, dataCreate);
                            //WHATSAPP
                            dataCreate = this.whatsappMsgTypeList.find(element => element.code == this.editableItem.waPatientTelehealthMSGType);
                            this.syncComboModel(this.waPatientTelehealthMSGTypeModel, dataCreate);

                            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                            //TELEHEALT :CONTACT
                            //EMAIL
                            dataCreate = this.emailMsgTypeList.find(element => element.code == this.editableItem.emailContactTelehealthMSGType);
                            this.syncComboModel(this.emailContactTelehealthMSGTypeModel, dataCreate);
                            //TEXT/SMS
                            dataCreate = this.smsMsgTypeList.find(element => element.code == this.editableItem.textContactTelehealthMSGType);
                            this.syncComboModel(this.textContactTelehealthMSGTypeModel, dataCreate);
                            //WHATSAPP
                            dataCreate = this.whatsappMsgTypeList.find(element => element.code == this.editableItem.waContactTelehealthMSGType);
                            this.syncComboModel(this.waContactTelehealthMSGTypeModel, dataCreate);
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async loadInitialData() {
            Promise.all([this.getLookupMsgTypes()])
                .then(() => {
                    this.getSchedulerOptions();
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        handleComboChange(selectedOption, params) {
            const codeValue = (selectedOption && selectedOption.code) ? selectedOption.code : null;
            const descValue = (selectedOption && selectedOption.code) ? selectedOption.description : null;

            this.editableItem[params.dbField] = codeValue;

            this.$set(params.uiModel, 'code', codeValue);
            this.$set(params.uiModel, 'description', descValue);
        },
    },

    created() {
        this.loadInitialData();
    },

    mounted() {
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
            }.bind(this)
        );
    },

    beforeDestroy() {
        EventBus.$off('onChanged');
    },
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$tc('SchedulerOptions.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        this.checkExistFavorite('/app/scheduleroptions');
                        next();
                    } else {
                        this.save();
                        next();
                    }
                });
        } else {
            next();
        }
    }
};
</script>
